// client/src/constants/shipping.js
// Kept in sync with the equivalent constants in ecommerce-app/server/index.js.
export const FREE_SHIPPING_THRESHOLD = 500;
export const FLAT_SHIPPING_FEE = 60;
export const ESTIMATED_DELIVERY_DAYS = '3-5 business days';

export const calculateShippingFee = (subtotal) => (subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : FLAT_SHIPPING_FEE);
